import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getMyIpInfo } from "@/services/ipInfoService";

export const IP_INFO_TTL_MS = 5 * 60 * 1000;

export const fetchIpInfo = createAsyncThunk(
  "network/fetchIpInfo",
  async (_, { rejectWithValue, signal }) => {
    try {
      return await getMyIpInfo({ signal });
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message ||
          error?.message ||
          "IP information is unavailable"
      );
    }
  },
  {
    condition: (_, { getState }) => {
      const network = getState().Network;
      if (network?.loading) return false;
      return !network?.expiresAt || Date.now() >= network.expiresAt;
    },
    dispatchConditionRejection: false,
  }
);

const initialState = {
  data: null,
  isIran: null,
  loading: false,
  checkedAt: 0,
  expiresAt: 0,
  error: null,
};

const networkSlice = createSlice({
  name: "network",
  initialState,
  reducers: {
    clearIpInfo: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchIpInfo.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchIpInfo.fulfilled, (state, action) => {
        const checkedAt = Date.now();
        state.data = action.payload;
        state.isIran = action.payload.isIran;
        state.loading = false;
        state.checkedAt = checkedAt;
        state.expiresAt = checkedAt + IP_INFO_TTL_MS;
        state.error = null;
      })
      .addCase(fetchIpInfo.rejected, (state, action) => {
        const checkedAt = Date.now();
        state.data = null;
        state.isIran = null;
        state.loading = false;
        state.checkedAt = checkedAt;
        state.expiresAt = checkedAt + IP_INFO_TTL_MS;
        state.error = action.payload || "IP information is unavailable";
      });
  },
});

export const { clearIpInfo } = networkSlice.actions;
export default networkSlice.reducer;
